// /api/v2 오류 — FastAPI 는 {"detail": "..."} 로 답한다. nginx 인증 게이트는 401(세션 없음)·403(서비스 권한 없음).

const maybeToJson = async (response: Response): Promise<{ detail?: unknown } | null> => {
  try {
    return await response.json();
  } catch (e) {
    return null;
  }
};

/** 중앙 세션이 없다(401) — 호출하는 쪽이 공용 로그인으로 보낸다 */
export class UnauthorizedError extends Error {
  constructor() {
    super("Unauthorized");
  }
}

export const throwAppError = async (response: Response): Promise<never> => {
  if (response.status === 401) {
    console.log(`[Error] HTTP 401`, response);
    throw new UnauthorizedError();
  }
  const body = await maybeToJson(response);
  const detail = typeof body?.detail === "string" ? body.detail : "";
  if (response.status === 403) {
    throw new Error(detail ? `권한이 없습니다 (${detail})` : "권한이 없습니다");
  }
  console.log(`[Error] HTTP ${response.status} ${detail}`, response);
  throw new Error(detail || `Unexpected response ${response.status}`);
};

export const fetchOrThrow = async (url: string, options?: RequestInit) => {
  const response = await fetch(url, { credentials: "same-origin", ...options });
  if (response.status < 200 || response.status > 299) {
    await throwAppError(response);
  }
  return response; // Promise!
};
